var _path, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAeroPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-20 -20 140 74",
    xmlSpace: "preserve",
    "data-icon": "true",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.925,5.721c-0.716-2.606-7.372-2.83-10.05-1.938c-9.739,3.239-19.479,6.479-29.22,9.719L26.845,0l-3.568,3.803 l14.468,17.376c-9.326,3.224-26.407,9.177-29.507,10.207c-2.669,0.889,17.247,3.715,21.813,2.956c0,0,35.082-11.443,50.593-16.604 c3.987-1.326,7.976-2.652,11.963-3.979C95.275,12.872,100.702,8.549,99.925,5.721z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "2.71,19.027 0,21.531 7.187,29.915 17.602,26.247"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeroPlane);
export default __webpack_public_path__ + "static/media/aeroPlane.7f150b1967cd51e61add8722e986fdc8.svg";
export { ForwardRef as ReactComponent };